import { ISectionData } from "./Section";

export class Part 
{
    public sections: ISectionData[];

    constructor(
        public title: string,
        public link?: string,
        sections?: ISectionData[]
    ) {
        this.sections = sections ?? [];
    }
}